(function($) {
	console.log(`MINESLONLINE JS v ${JS_VERSION}`)

	// auto focus to active panel in project details view
	$('#project-details .panel-group .panel').on('shown.bs.collapse', function( e ){
		var $panel = $(this).find('.panel-title');
	    $('html,body').animate({
	        scrollTop: $panel.offset().top - ( $('.main_header').height() + 100 )
	    }, 500); 
	});

	$('.breadcrumb-wrapper .go-back').on('click', function( e ){
		e.preventDefault();
		window.history.go( -1 );
	})
	
	var newsLoading = false;
	var page = 2;
	
	$(document).ready(function() {
		
		$(window).scroll(function() {	
			if($(window).scrollTop() > 40) {
				$('.section.headers').addClass('fixed');
				
			 } else {
				$('.section.headers').removeClass('fixed');
			}
			
			// News lazy load
			if ($(".news-releases").length > 0)
			{
			    if ($(window).scrollTop() + $(window).height() > $(".news-releases").offset().top + $(".news-releases").height() && !newsLoading)
			    {
			        newsLoading = true;
			        $(".loading_news").css("display", "block");
			        $.ajax({
                		url: ajaxsettings.ajaxurl,
                		type: 'post',
                		data: {
                			action: 'ajax_news',
				            query_vars: queryargs,
				            page: page
                		},
                		success: function( result ) {
			                $(".loading_news").css("display", "none");
                		    if (result.trim() == "") { return; }
                		    page++;
                		    $(".news-releases").append(result);
                		    $(".news-releases .post.teaser").matchHeight();
                		    newsLoading = false;
                		}
                	})
			    }
			}
		 });
		$(window).scroll();
		 
		 // $(document).on('click', '.navbar-toggle', function() {
			// $('.headers.navbar-collapse').slideToggle('slow');
			// $('.headers.navbar-collapse').toggleClass('in');
		 // });
		 
		 $(document).on('click', '.button,.buttons', function() {
			 var actions = $(this).data('action');
			 $('.modal-dialog').removeClass('form_signin').removeClass('form_signup');
			 if(typeof action != undefined){
				$('.register-form').each(function() {
					if($(this).hasClass(actions)) {
						$(this).addClass('active');		
						$('.modal-dialog').addClass('form_'+actions);				
					} else {
					//	$('.modal-dialog').removeClass('form_'+actions);
						$(this).removeClass('active');					
					}
				});
			 }
		 });
		 
		  $(document).on('click', '.showinterest a', function() {	
			  var actions ='signin';
			  $('.modal-dialog').addClass('form_signin').removeClass('showinterest');
			  $('.register-form').each(function() {
					if($(this).hasClass(actions)) {
						$(this).addClass('active');		
						$('.modal-dialog').addClass('form_'+actions);				
					} else {
					//	$('.modal-dialog').removeClass('form_'+actions);
						$(this).removeClass('active');					
					}
				});
		  });		  
		  
		$(document).on('click', '.show_register', function() {	
			var actions ='showinterest';
			$('.modal-dialog').removeClass('form_signin');
			$('.register-form').each(function() {
				if($(this).hasClass(actions)) {
					$(this).addClass('active');		
					$('.modal-dialog').addClass('form_'+actions);				
				} else {
					//	$('.modal-dialog').removeClass('form_'+actions);
					$(this).removeClass('active');					
				}
			});
		});

		/*
		 * Alter UPME register form
		 */
		 function copyEmailToUsername(form) {
		 	var email = $('.upme-user_email .upme-input', form).val();
		 		$('.upme-user_login .upme-input', form).val(email);
		 }
		 $('.upme-registration').each(function() {

		 	// return;

		 	var regform = this;

		 	// Copy labels to placeholders and hide labels
		 	$('.upme-field', regform).each(function() {
		 		
		 		var $field = $(this);

		 		var labelFor = $field.find('label').attr('for');

		 		if( labelFor == 'user_accept_terms' || labelFor == 'user_accept_privacy' ){
		 			return true;
		 		}

			 	var label = $(this).find('label span').not('.upme-required').text();
			 	$(this).find('.upme-input').attr('placeholder', label);
			 	$(this).find('label').hide(0);
			});

		 	// Fill the username with the email field and hide username field
		 	$('.upme-user_email .upme-input', regform).blur(function() {copyEmailToUsername(regform)});
		 	$('form', regform).submit(function() {copyEmailToUsername(regform)});
		 	$('#upme-register', regform).click(function() {copyEmailToUsername(regform)});
		 	$('.upme-user_login', regform).hide(0);

		 	// Re order fields
		 	$('#first_name', regform).closest('.upme-field').appendTo('#upme-registration-form');
		 	$('#last_name', regform).closest('.upme-field').appendTo('#upme-registration-form');
		 	$('.upme-user_email', regform).appendTo('#upme-registration-form');
		 	$('#phone_number', regform).closest('.upme-field').appendTo('#upme-registration-form');
	 		$('#user_company', regform).closest('.upme-field').appendTo('#upme-registration-form');
	 		$('#user_country', regform).closest('.upme-field').appendTo('#upme-registration-form');
	 		
	 		$('select#user_country option:first').text('Please select a country').prop( 'selected', true )

		 	$('.upme-user_pass', regform).appendTo('#upme-registration-form');
		 	$('.upme-user_pass_confirm', regform).appendTo('#upme-registration-form');
		 	$('input[name="user_accept_terms[]"], input[name="user_accept_privacy[]"]')
		 		.closest('.upme-field')
		 		.appendTo('#upme-registration-form')
		 		.end()
		 		.addClass('register-tnc')
		 	;
		 	
		 	$(".g-recaptcha").closest(".upme-field").appendTo('#upme-registration-form');
            $(".g-recaptcha").css('margin-bottom', "20px");
		 	
		 	var oldText = $('input[name="user_accept_terms[]"]')
		 		.closest('.upme-field')
		 		.find('label.upme-field-type span:not(".upme-required")').text()
		 	;
		 	var oldText2 = $('input[name="user_accept_privacy[]"]')
		 		.closest('.upme-field')
		 		.find('label.upme-field-type span:not(".upme-required")').text()
		 	;

		 	$('input[name="user_accept_terms[]"]')
		 		.closest('.upme-field')
		 		.find('label.upme-field-type span:not(".upme-required")')
		 			.html('<a target="blank" href="/terms-conditions/">' + oldText + '</a>')
		 	;
		 	
		 	// Hide the * & Change the text
		 	jQuery('input[name="user_accept_privacy[]"]').closest('.upme-field').find('label.upme-field-type span.upme-required').hide();
		 	$('input[name="user_accept_privacy[]"]')
		 		.closest('.upme-field')
		 		.find('label.upme-field-type span:not(".upme-required")')
		 			.html(oldText2 + ' <a target="blank" href="/privacy-policy/">Privacy Policy</a><span class="upme-required">&nbsp;*</span>')
		 	;
		 	

		 	$('input[name="user_accept_terms[]"]')
		 	$('#upme-register', regform).closest('.upme-field').appendTo('#upme-registration-form');

		 	// Add Bootstrap classes
		 	$('.upme-field', regform).addClass('form-group');
		 	$('input', regform).addClass('form-control');
		 	$('input[type=text], input[type=password]', regform).addClass('form-text');
		 	$('select', regform).addClass('form-select').addClass('forn-control');
		 	$('#upme-register', regform).addClass('btn').addClass('btn-info');
		 	$('#upme-register', regform).closest('.upme-field').addClass('form-submit');
		 	// Submit value
		 	$('#upme-register', regform).text("Register today - it's free!");
		 });

		 /*
		 * Alter UPME login form
		 */
		 $('.upme-login-wrapper').each(function() {
		 	var loginform = this;
		 	// Update field labels
		 	$('.upme-user_login label span', loginform).text("Email");
		 	// Copy labels to placeholders and hide labels
		 	$('.upme-field', loginform).each(function() {
			 	var label = $(this).find('label span').text();
			 	$(this).find('.upme-input').attr('placeholder', label);
			 	$(this).find('label').hide(0);
			 });
		 	// Remove unwanted elements
		 	$('.upme-clear', loginform).remove();
		 	$('.upme-rememberme', loginform).hide(0);
		 	// Add Bootstrap classes
		 	$(loginform).addClass('form-inline');
		 	$('.upme-field', loginform).addClass('form-group');
		 	$('input', loginform).addClass('form-control');
		 	$('input[type=text], input[type=password]', loginform).addClass('form-text');
		 	$('.upme-button.upme-login', loginform).addClass('btn').addClass('btn-primary');
		 	// Submit value
		 	$('.upme-button.upme-login', loginform).text("Login");
		 });

		 /*
		 * Alter UPME paaword form
		 */
		 $('.upme-reset-password-wrapper').each(function() {
		 	var form = this;
		 	// Update field labels
		 	$('.upme-user_name_email label span', form).text("Email");
		 	// Copy labels to placeholders and hide labels
		 	$('.upme-field', form).each(function() {
			 	var label = $(this).find('label span').text();
			 	$(this).find('.upme-input').attr('placeholder', label);
			 	$(this).find('label').hide(0);
			 });
		 	// Add Bootstrap classes
		 	$('.upme-field', form).addClass('form-group');
		 	$('input', form).addClass('form-control');
		 	$('input[type=text], input[type=password]', form).addClass('form-text');
		 	$('.upme-button.upme-login', form).addClass('btn').addClass('btn-primary').removeClass('upme-button');
		 });

		 /*
		 * Alter UPME profile form
		 */
		 $('.upme-edit-profile-form').each(function() {
		 	var form = this;
		 	// Copy labels to placeholders and hide labels
		 	$('.upme-field', form).each(function() {
			 	var label = $(this).find('label span').text();
			 	$(this).find('.upme-input').attr('placeholder', label);
			 	$(this).find('label').hide(0);
			 });
		 	// Remove unwanted elements
		 	$('.upme-clear', form).remove();
		 	// Add Bootstrap classes
		 	$('.upme-field', form).addClass('form-group');
		 	$('input', form).addClass('form-control');
		 	$('input[type=text], input[type=password]', form).addClass('form-text');
		 	$('.upme-button', form).addClass('btn').addClass('btn-primary');
		});

		 if( $('#upme-edit-profile-form').size() ){
		 	$('#upme-edit-profile-form .upme-field:last').before( $('#newsletter_signup_container') );		 	
		 }

		$('.carousel').on('slide.bs.carousel', function (e) {
	        var nextH = $(e.relatedTarget).height();
	        $(this).find('.active.item').parent().animate({
	            height: nextH
	        }, 500);
	    });

		// Custom mobile menu
		$('.section.headers .navbar-toggle').click(function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $navbartoggle = $(this);
			var $menu = $('.section.headers .navbar-collapse');
			var $offset = $('.responsive-menu-offset');
			var $content = $('.main-content-wrapper');
			var $navbar_btn = $('.navbar-toggle');
			var $logo = $('.site-title');
			var $buttons = $('.login-register');
			var push = "220px";
			if($menu.hasClass('collapse')) {
				$navbartoggle.addClass('active');
				$menu.stop().css('display', 'block').animate({right: 0}, 350, function() {
					$menu.removeClass('collapse');
				});
				$offset.stop().css('display', 'block').animate({right: 0}, 350);
				$content.stop().css('position', 'relative').animate({right: push}, 350);
				$navbar_btn.stop().animate({right: push}, 350);
				$buttons.stop().animate({right: push}, 350);
				$logo.addClass('notransition').stop().animate({left: "-200px"}, 350, function() {
					$logo.removeClass('notransition');
				});
			} else {
				$navbartoggle.removeClass('active');
				$menu.stop().animate({right: "-" + push}, 350, function() {
					$menu.addClass('collapse').css('display', 'none');
				});
				$content.stop().animate({right: 0}, 350, function() {
					$content.css('position', 'static');
				});
				$navbar_btn.stop().animate({right: 0}, 350);
				$buttons.stop().animate({right: 0}, 350);
				$logo.addClass('notransition').stop().animate({left: "20px"}, 350, function() {
					$logo.removeClass('notransition');
				});
				$offset.stop().animate({right: "-" + push}, 350, function() {
					$offset.css('display', 'none');
					$(window).trigger('resize.px.parallax');
				});
			}
			
		});

		$('.blog-posts .post.teaser').matchHeight();
		$('.project-search-results .project.teaser').matchHeight({
			property: 'min-height'
		});

		// Automatically open a modal if it contains a success message
		$(window).on('emodalInit', function(e) {
			var modal = e.target;
			if($(modal).find('.upme-success-block').size() > 0) {
				$(modal).emodal("open");
			}
		});

		$('.advanced-search .field-type-checkboxes .batch_action').on('click', function(e){

			e.preventDefault();

			var checked = $(this).hasClass('select_all') ? true : false;
			
			$(this)
				.closest( '.field-type-checkboxes' )
				.find( 'input[type="checkbox"]' )
				.each( function( i, el ){
					$(el).attr( 'checked', checked );					
				})
			;
		});	

		var formatDot = function( message ){

			message = message.substring( message.length - 1 ) == '.'
				? message
				: message + '. '
			;

			return message;
		}

		// renders flash message in the main content area
		var showFlash = function( message, type ){

			var $cont = $('<div/>')
				.addClass( 'flash-message alert alert-'+type+' alert-dismissible' )
				.attr('role', 'alert')
			;

			var $p = $('<p/>').html( message ),
				$button = $('<button/>')
					.addClass('close')
					.attr({'type': 'button', 'data-dismiss': 'alert', 'aria-label': 'Close'}),
				$close = $('<span/>').attr('aria-hidden', 'true').html('×').appendTo( $button )
			;

			$button.appendTo( $cont );
			$p.appendTo( $cont );

			if( $('body.home').size() ){
				$cont.prependTo( 'div.main-content-wrapper .banner_container');
			}
			else{
				$cont.prependTo( 'div.main-content.container .row .wrap');
			}			
		};

		// render flash message hidden in modals to main content area
		var $upme_success = $('#eModal-3 .upme-success');
		if( $upme_success.size() && $upme_success.text().trim().length ){
			var msgText = formatDot( $upme_success.text().trim() );
			showFlash( msgText + "<a href='#' class='eModal-3'>Click here</a>", 'success' );	
		}		

		var $upme_errors = $('#eModal-3 .upme-errors');
		if( $upme_errors.size() && $upme_errors.text().trim().length ){
			// Registration failed and the page reloaded, closing the modal.
			// Reopen it so the user sees the error inline instead of a blank page.
			var $regModal = $('#eModal-3');
			if( $regModal.length && typeof $regModal.emodal === 'function' ){
				setTimeout( function(){ $regModal.emodal('open'); }, 300 );
			} else {
				var msgText = formatDot( $upme_errors.text().trim() );
				showFlash( msgText + "<a href='#' class='eModal-3'>Try Again ?</a>", 'danger' );
			}
		}

	});
	
})( jQuery );